import { Box, BoxProps } from '@air/marketing-primitives';
import Image, { ImageProps } from 'next/image';

import { SECTION_CMS_LINK_CLASS_NAME } from '~/old-marketing/components/sections/Section';
import { SectionFieldTooltip } from '~/old-marketing/components/sections/SectionFieldTooltip';
import { usePreviewMode } from '~/providers/PreviewModeProvider';
import { contentfulImageLoader } from '~/utils/contentfulImageLoader';

export type SectionImageProps = Pick<BoxProps, 'css'> &
  Pick<ImageProps, 'height' | 'src' | 'width'> & {
    index?: number;
    isCMSLinked?: boolean;
  };

export const SectionImage = ({ css, height, index, isCMSLinked = true, src, width }: SectionImageProps) => {
  const { isPreview } = usePreviewMode();

  const element = (
    <Box
      className={isPreview && isCMSLinked ? SECTION_CMS_LINK_CLASS_NAME : ''}
      css={{
        display: 'inline-block',

        /**
         * Overrides Next.js image styles to remove extra 4px
         * spacing from the bottom of the component.
         */
        '> span': {
          display: 'block !important',
        },

        ...css,
      }}
    >
      <Image height={height} loader={contentfulImageLoader} src={src} width={width} />
    </Box>
  );

  return isCMSLinked ? (
    <SectionFieldTooltip field={`Asset${index && `(${index})`}`}>{element}</SectionFieldTooltip>
  ) : (
    element
  );
};
